<template>
  <el-card class="box-card">
    <el-row :gutter="30" :justify="'center'">
      <el-col :span="4">
        <div class="grid-content">
          <el-menu :style="'background: inherit'">
            <NotificationMenuItem :state="1" icon="el-icon-folder" title="Arquivos" :total="received"
              @click="(state) => option = state" />
            <NotificationMenuItem :state="2" icon="el-icon-receiving" title="Mensagens" :total="messages"
              @click="(state) => option = state" />
          </el-menu>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="grid-content">
          <span>
            <FilesMessages v-if="option === 1" v-for="(item, index) of files" :key="index" :index="index" :file="item"
              v-on:delete="removeFile" />
            <Messages :userType="userType" v-if="option === 2" v-on:delete="remove" />
          </span>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import Messages from "@/xpost/views/comum/notification/message/Messages";
import FilesMessages from "@/xpost/views/comum/notification/FilesMessages";
import { UserService } from "@/services/users/user.services";
import NotificationMenuItem from "./NotificationMenuItem.vue";
import { NotificationService } from "@/services/comum/notification.services";

export default {
  data() {
    return {
      option: 1,
      messages: 0,
      userType: '2',
      users: null,
      files: [],
    };
  },
  methods: {
    fetchNotifications() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      NotificationService.count(0)
        .then((response) => {
          vm.messages = +response;
        })
        .catch((err) => {
        })
        .finally(() => loading.close());
      UserService.listNotifications()
        .then((response) => {
          vm.files = response;
        })
        .catch((err) => {
        })
        .finally(() => loading.close());
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    remove(quantity) {
      const vm = this;
      if (vm.messages - quantity < 0) vm.messages = 0;
      else vm.messages -= quantity;
    }
  },
  computed: {
    received() {
      return this.files.length;
    },

  },
  components: {
    Messages,
    FilesMessages,
    NotificationMenuItem
  },
  mounted() {
    if (this.$route.params && this.$route.params.to && this.$route.params.to === 'message') {
      this.option = 2;
    }
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
    this.fetchNotifications();
  },
};
</script>

<style>
.messages-number {
  margin-left: 140px;
  position: absolute;
  background-color: #22418d;
}

.messages-number-box {
  position: absolute;
  right: 0px;
  border: 1px solid #f6921e;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  border-radius: 5px;
  color: #f6921e;
}
</style>
